import { render, staticRenderFns } from "./BlogPublishMailDialog.vue?vue&type=template&id=5eda105a&scoped=true"
import script from "./BlogPublishMailDialog.vue?vue&type=script&lang=ts"
export * from "./BlogPublishMailDialog.vue?vue&type=script&lang=ts"
import style0 from "./BlogPublishMailDialog.vue?vue&type=style&index=0&id=5eda105a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda105a",
  null
  
)

export default component.exports